import type { ReactElement } from "react";

type FinanceFilterFieldProps = {
  children: ReactElement;
  label: string;
};

export default function FinanceFilterField({
  children,
  label,
}: FinanceFilterFieldProps) {
  return (
    <label className="text-xs font-semibold text-slate-600">
      {label}
      <span className="mt-1 block font-normal [&_.p-multiselect]:w-full [&_.p-multiselect]:rounded-lg [&_.p-multiselect]:border-slate-300 [&_.p-multiselect]:text-sm [&_.p-multiselect-label]:py-2 [&_.p-multiselect-token]:max-w-32 [&_.p-multiselect-token-label]:truncate [&_select]:w-full [&_select]:rounded-lg [&_select]:border [&_select]:border-slate-300 [&_select]:bg-white [&_select]:px-3 [&_select]:py-2 [&_select]:text-sm [&_select]:font-normal">
        {children}
      </span>
    </label>
  );
}
